import { ActivatedRouteSnapshot, DetachedRouteHandle } from '@angular/router';
import { IonicRouteStrategy } from '@ionic/angular';

export class CustomRouteReuseStrategy extends IonicRouteStrategy {
  // Routes that should NOT be cached (will be destroyed on navigation away)
  private routesToNotCache = [
    '/edit-point',
    '/moderation'
  ];

  /**
   * Override shouldReuseRoute to prevent caching of specific routes
   */
  override shouldDetach(route: ActivatedRouteSnapshot): boolean {
    // Check if this route should not be cached
    const path = this.getFullPath(route);
    
    if (this.shouldNotCache(path)) {
      console.log('🚫 Not caching route:', path);
      return false;
    }

    // Use default Ionic behavior for other routes
    return super.shouldDetach(route);
  }

  /**
   * Override retrieve to ensure we don't retrieve cached versions of non-cached routes
   */
  override retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
    const path = this.getFullPath(route);
    
    if (this.shouldNotCache(path)) {
      console.log('🚫 Not retrieving cached route:', path);
      return null;
    }

    return super.retrieve(route);
  }

  /**
   * Get full path from route snapshot
   */
  private getFullPath(route: ActivatedRouteSnapshot): string {
    if (route.routeConfig?.path) {
      return '/' + route.routeConfig.path;
    }
    
    // Build path from URL segments
    let path = '';
    let currentRoute: ActivatedRouteSnapshot | null = route;
    
    while (currentRoute) {
      if (currentRoute.url.length > 0) {
        path = '/' + currentRoute.url.map(segment => segment.path).join('/');
        break;
      }
      currentRoute = currentRoute.parent;
    }
    
    return path || '/';
  }

  /**
   * Check if a route should not be cached
   */
  private shouldNotCache(path: string): boolean {
    return this.routesToNotCache.some(route => path.includes(route));
  }
}
